import { ISelectedPromotionInfoSchema } from '../../../repositories/monolith-python/entities/SelectedPromotionInfoSchema';
import { ISelectedPromotionInfo } from '../types';
import { mapServiceTypes, getServiceId } from '../../../utils/publishTerms';

export function mapSelectedPromotionInfo(selectedPromotionInfo: ISelectedPromotionInfoSchema): ISelectedPromotionInfo {
  const serviceTypes = mapServiceTypes(selectedPromotionInfo.serviceTypes);

  return {
    serviceId: getServiceId(serviceTypes),
  };
}
